import { useEffect } from 'react';
import classNames from 'classnames';
import { Flex } from 'antd';

import BaseRoutePath from '@Router/baseRoutePathes.enum';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { useNavigate } from 'react-router-dom';
import { MButton } from '@Components/Base';
import backgroundImage from '@Images/login-page-background.jpg';
import logoImage from '@Images/logo-dark.png';

import styles from './login-page.module.css';

const LoginPage: React.FC = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const redirectURL = sessionStorage.getItem('redirectURL');
      if (redirectURL) {
        navigate(redirectURL);
        sessionStorage.removeItem('redirectURL');
      } else {
        navigate(BaseRoutePath.HOME);
      }
    }
  }, [isAuthenticated]);

  const handleAuthWithAzureAD = async (): Promise<void> => {
    try {
      await instance.loginRedirect({
        scopes: ['email'],
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className={styles.loginPage}>
        <div
          className={styles.backgroundImage}
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        />
        <Flex
          justify="center"
          className={classNames('trojan-box-shadow', styles.box)}
        >
          <div className={classNames('trojan-container', styles.container)}>
            <Flex vertical className={styles.textSection}>
              <div className={styles.caption}>Welcome To Trojan Portal,</div>
              <div className={styles.subCaption}>
                Your Central Workspace For All Your Needs!
              </div>
            </Flex>
            <Flex vertical className={styles.buttonSection} justify="center">
              <MButton onClick={handleAuthWithAzureAD} type="primary">
                Login
              </MButton>
            </Flex>
          </div>
        </Flex>
      </div>
      <div className={styles.logo}>
        <img src={logoImage} alt="" />
      </div>
    </>
  );
};

export default LoginPage;
